// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"328":"admin","378":"user","787":"guest"}[chunkId] || chunkId) + "." + {"132":"24d9929556ee1511fbe7","328":"32b894989718f9e2efa0","378":"a19aa185668c27bf0cb3","583":"d5794866871ca061498d","787":"6c70d6431302e2375df3"}[chunkId] + ".css";
};